import React from 'react';

export default function Clients() {
  return (
    <section id="clients" className="relative py-20 flex items-center justify-center min-h-[60vh]">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center z-0"
        style={{ 
          backgroundImage: 'url("https://static.lumi.new/87/87dabfc34549fd1372699bd20e9469e4.png")',
        }}
      />
      <div className="absolute inset-0 bg-black/70 z-10" />

      <div className="relative z-20 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6">Nossos Clientes</h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto"></div>
        </div>

        <div className="bg-white/90 backdrop-blur-sm rounded-3xl p-12 shadow-2xl transform hover:scale-[1.01] transition-transform duration-300">
          <div className="flex flex-col items-center justify-center text-center min-h-[200px]">
            <p className="text-gray-500 text-lg italic mb-4">
              Espaço reservado para parceiros e clientes da Aeromaps Bahia.
            </p>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8 w-full">
              {/* Client Logos */}
              <div className="h-32 bg-white rounded-lg flex items-center justify-center p-4 transform hover:scale-110 transition-transform duration-300 shadow-lg hover:shadow-2xl">
                <img src="https://lh3.googleusercontent.com/d/1rxgicIn6QKpdafj7Ypt_7fEh5sefF0l6" alt="Cliente 1" className="max-h-full max-w-full object-contain" />
              </div>
              <div className="h-32 bg-white rounded-lg flex items-center justify-center p-4 transform hover:scale-110 transition-transform duration-300 shadow-lg hover:shadow-2xl">
                <img src="https://lh3.googleusercontent.com/d/1tvE1oJnV9jvMios5QJ4J11_a6JikSjiR" alt="Cliente 2" className="max-h-full max-w-full object-contain" />
              </div>
              <div className="h-32 bg-white rounded-lg flex items-center justify-center p-4 transform hover:scale-110 transition-transform duration-300 shadow-lg hover:shadow-2xl">
                <img src="https://lh3.googleusercontent.com/d/1u4fwsvG4aNjb0mO8R0CNzqD0L_WSmGg7" alt="Cliente 3" className="max-h-full max-w-full object-contain" />
              </div>
              <div className="h-32 bg-white rounded-lg flex items-center justify-center p-4 transform hover:scale-110 transition-transform duration-300 shadow-lg hover:shadow-2xl">
                <img src="https://lh3.googleusercontent.com/d/1pmNFLElrkWocvaJXJd5fGZqDUl_HQzx_" alt="Cliente 4" className="max-h-full max-w-full object-contain" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
